import Card from 'components/Card/Card';
import { BodyMBold, BodyS, HeadingLBold } from 'components/Typography/Typography';
import React from 'react';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import { useHistory } from 'react-router-dom';

const Faq = () => {
	const history = useHistory();

	const handleButton = () => {
		history.goBack();
	};

	return (
		<div>
			<Button color="primary-light" onClick={handleButton}>
				{translate('back')}
			</Button>
			<Card>
				<div style={{ padding: '32px' }}>
					<HeadingLBold>{translate('path.faq')}</HeadingLBold>
					<ol>
						<li>
							<BodyMBold>{translate('faq.product.in.stock.question')}</BodyMBold>
							<BodyS>{translate('faq.product.in.stock.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.payment.methods.question')}</BodyMBold>
							<BodyS>{translate('faq.payment.methods.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.voucher.question')}</BodyMBold>
							<BodyS>{translate('faq.voucher.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.delivery.question')}</BodyMBold>
							<BodyS>{translate('faq.delivery.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.vat.question')}</BodyMBold>
							<BodyS>{translate('faq.vat.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.delivery.charges.question')}</BodyMBold>
							<BodyS>{translate('faq.delivery.charges.answer')}</BodyS>
						</li>
						<li>
							<BodyMBold>{translate('faq.order.time.question')}</BodyMBold>
							<BodyS>{translate('faq.order.time.answer')}</BodyS>
						</li>
					</ol>
				</div>
			</Card>
		</div>
	);
};

export default Faq;
